module.exports = __webpack_public_path__ + "img/jishi.b08726d9.svg";